<template>
  <mdb-container>
    <Errors v-if="!!error" :error="error" />
    <mdb-row>
      <mdb-col v-if="showSpinner">
        <Spinner />
      </mdb-col>
    </mdb-row>

    <mdb-alert
      color="dark"
      v-if="message"
      @closeAlert="message = false"
      dismiss
    >
      {{ message }}
    </mdb-alert>

    <form @submit.prevent="createLocation">
      <mdb-col col="12" class="pb-2 justify-content-md-center">
        <mdb-row>

          <mdb-col col="4">
            <mdb-input label="New Location Name" v-model="locationInfo.name" @change="validateLocationName" placeholder="e.g. Franklin" required />
          </mdb-col>

          <mdb-col col="4">
            <mdb-input label="Location Code" disabled v-model="locationInfo.code" placeholder="Please enter location name" required />
          </mdb-col>

           <mdb-col col="4">
            <mdb-input label="Description" v-model="locationInfo.description" placeholder="additional details" required />
          </mdb-col>
          <mdb-col col="4">
            <mdb-btn
              :disabled="!isDisabled"
              outline="primary"
              type="submit"
              :icon="btnInfo.btnIcon"
              >{{ btnInfo.btnName }}</mdb-btn
            >
          </mdb-col>
        </mdb-row>
      </mdb-col>
    </form>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Errors from "@/components/Errors";
import Spinner from "@/components/Spinner";

import {
  mdbRow,
  mdbCol,
  mdbContainer,
  mdbBtn,
  mdbAlert,
  mdbInput,
} from "mdbvue";

export default {
  components: {
    Errors,
    mdbRow,
    mdbCol,
    mdbContainer,
    mdbBtn,
    mdbAlert,
    Spinner,
    mdbInput
  },

  data() {
    return {
      locationInfo: {},
      error: "",
      btnInfo: {},
      isLoading: true,
      message: "",
    };
  },
  methods: {
    newLocation() {
      return {
        name: "",
        code: "",
        description: "",
      };
    },

    createLocation() {
      api
        .createLocation(this.locationInfo)
        .then(() => {
          this.$emit("location-created");
          this.reset();
        })
        .catch((error) => {
          this.error = error.response.data.errors.full_messages[0];
        });
    },
    reset() {
      this.locationInfo = this.newLocation();
      this.errors = {};
    },
    setBtnInfo() {
      return { btnName: "Create Location", btnIcon: "plus" };
    },
    validateLocationName() {
       this.locationInfo.name = this.locationInfo.name.charAt(0).toUpperCase()+this.locationInfo.name.slice(1);
       this.locationInfo.code = this.locationInfo.name.toLowerCase().replace(' ', '_');
    },
  },

  created() {
    this.locationInfo = this.newLocation();
    this.btnInfo = this.setBtnInfo();
    this.isLoading = false;
  },
  mounted() {},
  computed: {
    showSpinner() {
      return this.isLoading;
    },
    isDisabled() {
      return (
        !!this.locationInfo.name &&
        !!this.locationInfo.code &&
        !!this.locationInfo.description
      );
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  color: $black-accent-color;
  border-color: $black-accent-color;
  text-transform: uppercase;

  &:hover {
    background-color: $green-accent-color;
    color: white;
  }
}
</style>
